import { TODO, Timestamp } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import moment from 'moment-timezone';
import { SubscriptionsListServiceModule } from './SubscriptionsList.service';
import { SubscriptionsListEndDatePickerControllerModule } from './SubscriptionsListEndDatePickerController';
import { SubscriptionsListStartDatePickerControllerModule } from './SubscriptionsListStartDatePickerController';

SubscriptionsListController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  'ApiService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'UserPreferencesService',
  'SubscriptionsListService',
  'HelpersService',
  'CalendarService',
];

function SubscriptionsListController(
  $scope: IScope & { subscriptionsList: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  ApiService: TODO,
  GridStateFactory: TODO,
  GridDefinitionFactory: TODO,
  UserPreferencesService: TODO,
  SubscriptionsListService: TODO,
  HelpersService: TODO,
  CalendarService: TODO,
) {
  const ctrl = {
    model: [],

    gridDefinition: new GridDefinitionFactory(),
    gridState: new GridStateFactory(),
    userPreferencesLoaded: false,
    viewId: '',
    gridName: $state.current.name + '.grid0',

    filterDateType: [
      {
        type: 'updatedOn',
        name: 'Updated On',
      },
      {
        type: 'statusChangeDate',
        name: 'Status Change Date',
      },
      {
        type: 'membershipExpirationDate',
        name: 'Membership Expiration Date',
      },
    ] as const,
    
    filterType: { type: 'updatedOn' }  as { type: 'updatedOn' | 'statusChangeDate' | 'membershipExpirationDate' },

    filterStatusOptions: [
      {
        label: 'Active',
        value: 'active',
        checked: true,
      },
      {
        label: 'Canceled',
        value: 'canceled',
        checked: true,
      },
      {
        label: 'Failed',
        value: 'failed',
        checked: true,
      },
      {
        label: 'Pending',
        value: 'pending',
        checked: true,
      },
      {
        label: 'Replaced',
        value: 'replaced',
        checked: true,
      },
      {
        label: 'No Payment Method',
        value: 'noPaymentMethod',
        checked: true,
      },
    ] as const,

    filterStatus: [],

    startDate: new Date(),
    endDate: new Date(),

    ranges: CalendarService.ranges,
    dateMode: 'custom',

    startingDay: UserPreferencesService.getStartDayOfWeek(),
    dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
    headerDateFormat: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

    optionsOverride: {
      data: 'subscriptionsList.model',
      exporterMenuCsv: false,
      exporterMenuPdf: false,
      enableGridMenu: true,
      rowClasses: "{ 'ui-grid-row-header-cell': col.isRowHeader, 'capitalize': true  }",
      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          width: 50,
          onCellNavClick: function (row, col) {
            ctrl.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View</a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
          suppressSizeToFit: true,
        },
        {
          field: 'originatingPlanId',
          displayName: 'Original Subscription ID',
          visible: true,
        },
        {
          field: 'id',
          displayName: 'Subscription ID',
          visible: false,
        },
        {
          field: 'customerName',
          displayName: 'Subscriber',
          visible: true,
        },
        {
          field: 'status',
          displayName: 'Status',
          visible: true,
        },
        {
          field: 'updatedOn',
          displayName: 'Updated',
          visible: true,
          cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.sortDate);
          },
        },
        {
          field: 'statusChangeDate',
          displayName: 'Status Change Date',
          visible: true,
          cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.sortDate);
          },
        },
        {
          field: 'nextPaymentDate',
          displayName: 'Next Payment Date',
          visible: true,
          cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.sortDate);
          },
        },
        {
          field: 'externalMembershipId',
          displayName: 'External Membership Number',
          visible: true,
        },
        {
          field: 'membershipLevelName',
          displayName: 'Membership Level Name',
          visible: true,
        },
        {
          field: 'membershipOfferingName',
          displayName: 'Membership Offering Name',
          visible: true,
        },
        {
          field: 'membershipStanding',
          displayName: 'Membership Standing',
          visible: true,
        },
        {
          field: 'membershipExpirationDate',
          displayName: 'Membership Expiration date',
          visible: true,
          cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.sortDate);
          },
        },
        {
          field: 'cardType',
          displayName: 'Card Type',
          visible: false,
        },
        {
          field: 'ccLastFourDigits',
          displayName: 'Card Last 4 digits',
          visible: false,
        },
        {
          field: 'ccExpirationDate',
          displayName: 'Card expiration date',
          visible: false,
          cellFilter: 'date: "' + HelpersService.dateFormats.ccExpirationDateAlt + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.ccExpirationDateAlt);
          },
        },
        {
          field: 'createdOn',
          displayName: 'Opt-in date',
          visible: false,
          cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
          cellFormatter: function (item) {
            return $filter('date')(item.value, HelpersService.dateFormats.sortDate);
          },
        },
      ],
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function (grid, columns, page) {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          ctrl.onDblClick(item);
        },
      },
    },

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Subscriptions List',
      });

      ctrl.gridState.setPropertyValue('sortField', 'updatedOn');

      ctrl.filterType = ctrl.filterDateType[0];

      ctrl.viewId = $state.current.name ?? '';
      ctrl.gridDefinition.init(ctrl.gridName, ctrl.optionsOverride, ctrl.viewId, $state.current.data.enablePreferences);

      ctrl.initDatePicker();

      $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData));
      $scope.$on('$destroy', $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad));
    },

    initRanges: function () {
      for (let i = 0, ii = this.ranges.length; i < ii; i++) {
        this.ranges[i].logic(new Date());
      }
      return this.ranges[0];
    },

    initDatePicker: function () {
      SubscriptionsListService.init();
      ctrl.startDate = SubscriptionsListService.getStartDate();
      ctrl.endDate = SubscriptionsListService.getEndDate();
    },

    getToday: function () {
      const date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      return date;
    },

    isDateMode: function (mode) {
      return this.dateMode === mode;
    },

    setDateMode: function (mode) {
      if (this.dateMode !== mode && this.selectedRange) {
        const range = this.selectedRange.logic(new Date());
        this.fromDate = range.startDate;
        this.toDate = range.endDate;
      }

      this.dateMode = mode;
    },

    onDateFormatLoad: function (e, data) {
      ctrl.startingDay = UserPreferencesService.getStartDayOfWeek();
      ctrl.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
      ctrl.headerDateFormat = UserPreferencesService.getDateFormat('extendedDate', 'dateFormat');
      ctrl.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
    },

    initData: function () {
      const props = ctrl.gridDefinition.getGridState();

      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      ctrl.search();
    },

    search: function () {
      const range = this.selectedRange.logic(new Date());
      const defaultProps = ctrl.gridState.getGridState();
      const props: { 
        status?: string;
        filterType: string; 
        startDate?: Timestamp; 
        endDate?: Timestamp } = {
        filterType: 'updatedOn',
      };

      ctrl.gridDefinition.isLoaded = false;

      props.status = ctrl.filterStatus
        .filter((status: TODO) => status.checked)
        .map((status: TODO) => status.value)
        .join(',');

      props.filterType = ctrl.filterType.type;

      if (this.isDateMode('custom')) {
        props.startDate = moment(ctrl.startDate).format();
        props.endDate = moment(ctrl.endDate).hour(23).minute(59).second(59).format();
      } else {
        props.startDate = moment(range.startDate).format();
        props.endDate = moment(range.endDate).hour(23).minute(59).second(59).format();
      }

      console.log('SubscriptionsListController::search > startDate', props.startDate);
      console.log('SubscriptionsListController::search > endDate', props.endDate);

      ApiService.subscriptions.list($.extend(props, defaultProps)).then(ctrl.success.search, ctrl.error.search);
    },

    process: function (list) {
      ctrl.model = list.map(function (item) {
        const result = item;
        result.customerName = item.customerFirstName + ' ' + item.customerLastName;
        return result;
      });
    },

    success: {
      init: function (response) {},
      search: function (res) {
        console.log('SubscriptionsListController::success::search', res);

        ctrl.process(res.data.payload.list);
        ctrl.gridDefinition.isLoaded = true;

        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.model.length,
            totalItems: res.data.payload.pagination.count,
          });
        }, 10);
      },
    },

    error: {
      init: function (response) {},
      search: function (res) {
        console.log('SubscriptionsListController::error::search', res);
      },
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        ctrl.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.gridState.updateGridState(null, null, null, sortDirection);
      }
      ctrl.search();
    },

    onDataGridSortChange: function (grid, columns, page) {
      const data = columns[0];
      ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
      ctrl.search();
    },

    onDblClick: function (item) {
      $state.go('application.subscriptions.detail', { id: item.entity.membershipId });
    },
  };

  $scope.subscriptionsList = ctrl;
  ctrl.init();
}

export const SubscriptionsListControllerModule = angular
  .module('acme.view.application.subscriptions.list.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.calendar',
    SubscriptionsListServiceModule,
    SubscriptionsListStartDatePickerControllerModule,
    SubscriptionsListEndDatePickerControllerModule,
  ])

  .controller('SubscriptionsListController', SubscriptionsListController).name;
